import rill from "rill";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import ensurePerformUpgrade from "../../../middleware/ensure-perform-upgrade";
import {
  getRoot,
  postAddMember,
  postConvertToPull,
  postRemove,
} from "./gym-members.controller";

const GymMembers = (app) => {
  app.at(
    "/gym-members/*",
    rill().setup((app) => {
      app
        .get(
          "/",
          ensurePerformUpgrade,
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["PERFORM"],
              "/coaching-portal/athletes"
            ),
          getRoot
        )
        .post("/add-member", postAddMember)
        .post("/remove", postRemove)
        .post("/convert-to-pull", postConvertToPull);
    })
  );
};

export default GymMembers;
